import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { useEffect, useState, type JSX } from 'react';
import { SWRResponse } from 'swr';
import { AutomationRuleTriggersEnum } from '../triggers/enums/trigger-enum';
import { AutomationRulesTriggersType } from '../triggers/types/automation-rule-trigger-interface';
import { AutomationRulesTriggersEditType } from '../triggers/types/automation-rule-triggers-edit-interface';
import { AutomationRuleApiInterface, RuleId } from '../types/automation-rule-interface';
import SpecificTriggerRuleCreate from './components/specific-trigger-rule-create';
import SpecificTriggerRuleEdit from './components/specific-trigger-rule-edit';
import SpecificTriggerRuleError from './components/specific-trigger-rule-error';
import SpecificTriggerRulesTable from './components/specific-trigger-rules-table';
export interface SpecificTriggerRulesProps {
  specificTriggerRulesData: SWRResponse<AutomationRuleApiInterface>;
  availableTriggersData: SWRResponse<AutomationRuleTriggersEnum[]>;
  noRelatedMessage: (ruleId: RuleId) => string | JSX.Element;
  getRelatedAndUnrelatedTriggersData: <T extends AutomationRulesTriggersEditType | AutomationRulesTriggersType>(triggers: Array<T>) => {
    relatedTriggers: T[];
    unrelatedTriggers: T[];
  };
  customAddTriggerHandler?: (trigger: AutomationRuleTriggersEnum, maxTriggerId: React.MutableRefObject<number>) => AutomationRulesTriggersEditType;
}
export default function SpecificTriggerRules(t0) {
  const $ = _c(19);
  const {
    availableTriggersData,
    getRelatedAndUnrelatedTriggersData,
    specificTriggerRulesData,
    customAddTriggerHandler,
    noRelatedMessage
  } = t0;
  const [commonError, setCommonError] = useState("");
  const [selectedRuleId, setSelectedRuleId] = useState();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setSelectedRuleId(undefined);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const clearSelectedRule = t1;
  let t2;
  let t3;
  if ($[1] !== specificTriggerRulesData.error) {
    t2 = () => {
      if (specificTriggerRulesData.error && specificTriggerRulesData.error instanceof BadRequest && specificTriggerRulesData.error.errors.common) {
        setCommonError(specificTriggerRulesData.error.errors.common.join(""));
      }
    };
    t3 = [specificTriggerRulesData.error];
    $[1] = specificTriggerRulesData.error;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== availableTriggersData.error) {
    t4 = () => {
      if (availableTriggersData.error && availableTriggersData.error instanceof BadRequest && availableTriggersData.error.errors.common) {
        toast.error(availableTriggersData.error.errors.common.join(""));
      }
    };
    t5 = [availableTriggersData.error];
    $[4] = availableTriggersData.error;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== commonError) {
    t6 = <SpecificTriggerRuleError error={commonError} />;
    $[7] = commonError;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== availableTriggersData || $[10] !== customAddTriggerHandler || $[11] !== getRelatedAndUnrelatedTriggersData || $[12] !== noRelatedMessage || $[13] !== selectedRuleId || $[14] !== specificTriggerRulesData) {
    t7 = selectedRuleId ? <SpecificTriggerRuleEdit noRelatedMessage={noRelatedMessage} mutateRules={specificTriggerRulesData.mutate} mutateAvailableTriggers={availableTriggersData.mutate} clearSelectedRule={clearSelectedRule} ruleId={selectedRuleId} availableTriggers={availableTriggersData.data} getRelatedAndUnrelatedTriggersData={getRelatedAndUnrelatedTriggersData} customAddTriggerHandler={customAddTriggerHandler} /> : <>{!specificTriggerRulesData.error && <SpecificTriggerRulesTable noRelatedMessage={noRelatedMessage} mutateAvailableTriggers={availableTriggersData.mutate} setSelectedRuleId={setSelectedRuleId} mutateRules={specificTriggerRulesData.mutate} rules={specificTriggerRulesData.data} getRelatedAndUnrelatedTriggersData={getRelatedAndUnrelatedTriggersData} />}<SpecificTriggerRuleCreate noRelatedMessage={noRelatedMessage} availableTriggersData={availableTriggersData} getRelatedAndUnrelatedTriggersData={getRelatedAndUnrelatedTriggersData} specificTriggerRulesData={specificTriggerRulesData} customAddTriggerHandler={customAddTriggerHandler} /></>;
    $[9] = availableTriggersData;
    $[10] = customAddTriggerHandler;
    $[11] = getRelatedAndUnrelatedTriggersData;
    $[12] = noRelatedMessage;
    $[13] = selectedRuleId;
    $[14] = specificTriggerRulesData;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}